import { Component, OnInit, ViewChild, ElementRef, Renderer2, Injector } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ProductApprovalOrRejectModalComponent } from '../product-approval-or-reject-modal/product-approval-or-reject-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrderServiceProxy, OrderApprovalUserDto } from '../../../../../../../shared/service-proxies/service-proxies';
import { ApproveStatusModalComponent } from '../approve-status-modal/approve-status-modal.component';
import { ImageModalComponent } from '../../wizards/step3/image-modal/image-modal.component';
import { AppComponentBase } from '../../../../../../../shared/app-component-base';
import { CustomLocalizationService } from '../../../utility/customLocalization.service';
import { AppConsts } from '@shared/AppConsts';


enum orderOperationType {
	Approve = 1,
	Rejected = 0
}

@Component({
  selector: 'kt-my-pending-requests',
  templateUrl: './my-pending-requests.component.html',
  styleUrls: ['./my-pending-requests.component.scss']
})
export class MyPendingRequestsComponent extends AppComponentBase implements OnInit {

	@ViewChild('approvaStatus', { static: true }) approvaStatus: ElementRef;

	approvalDateFilters = [
		//{ key: 0, value: "Hepsi" },
		{ key: this.localization.localize("FE.APPROVALS.FILTERS.DATEFILTER.PAST7DAYS", this.localizationSourceName), value: 7 },
		{ key: this.localization.localize("FE.APPROVALS.FILTERS.DATEFILTER.PAST14DAYS", this.localizationSourceName), value: 14 },
		{ key: this.localization.localize("FE.APPROVALS.FILTERS.DATEFILTER.PAST21DAYS", this.localizationSourceName), value: 21 },
		{ key: this.localization.localize("FE.APPROVALS.FILTERS.DATEFILTER.PAST30DAYS", this.localizationSourceName), value: 30 },
		{ key: this.localization.localize("FE.APPROVALS.FILTERS.DATEFILTER.PAST60DAYS", this.localizationSourceName), value: 60 },
		{ key: this.localization.localize("FE.APPROVALS.FILTERS.DATEFILTER.PAST90DAYS", this.localizationSourceName), value: 90 },

	]

	selectedProductList = [];
	
	sumDeci = new BehaviorSubject<number>(0);

	//son kaç günün listesinden seçtiği gün bilgisini tutar.
	//Mesela: son 7 gün gibi.
	selectedLastNumberDayObj;

	//productList = [];
	
	//Sayfa ilk yüklendiği anda getirilecek son 7 gün mesela gibi. 
	DefaultSelectedLastNumberDayObj;
	
	productList = new BehaviorSubject<any[]>([]);

	constructor(private modalService: NgbModal,
		private _orderService: OrderServiceProxy,
		private customLocalization: CustomLocalizationService,
		private renderer2: Renderer2,
		injector: Injector,

	)
	{
		super(injector);
	}

	ngOnInit() {
		
		//sayfa yüklendiği anda varsayılan seçili olarak gelmesini istediğimiz gün.
		//this.selectedLastNumberDayObj = this.numberOfDaysList[0].key;

		//Sayfa yüklendiği anda son kaç günün listesi isteniyorsa o gün sayısını barındırır.
		//this.DefaultSelectedLastNumberDayObj = this.numberOfDaysList[0];

		this.selectedLastNumberDayObj = this.approvalDateFilters[0];

		var defaultDateValue = this.approvalDateFilters[0].value;

		this.productLoadList(defaultDateValue);

	}

	//#region Ürün listesi yükleyici

	productLoadList(dateValue) {

		//Burak abinin verdiği method buraya yazılacak ve extra olarak gün sayısı method içerisinde verilerek
		//asyncResultproductList içerisine atılacak.

		this._orderService.getWaitingForApprovalOrders(dateValue).subscribe(plist => {

			var numberholder = 0;
			console.log("onayımı bekleyen talepler sayfasıdan ki datalar:" + plist);
			this.productList.next(plist);
			//this.productList = plist;

			plist.forEach(obj => {
				numberholder += (+obj.productDeci) * obj.qty;
			})

			this.sumDeci.next(+(numberholder.toFixed(2)));

		})
	}

		//#endregion


	//#region tüm ürünlerin seç ya da tüm ürünleri iptal et


	//Hepsini şeç checkboxı tıklanıldığında diğer irin gridinde ki butonların şeçilmesini sağlar.
	checkboxSelectAll(selectProducts) {
		//pRow selectorunun içerisinde bulunduğu tüm yerleri alır. yani row ların hepsini buradan alırız.
		document.querySelectorAll('.myPenReqPRow').forEach((el) => {

			//Checkbox elementine eriştik.
			let checkBox = el.querySelector('.myPenReqPRowEdit-col input') as HTMLInputElement;

			if (!!checkBox) {

				//Eğer tıklanılan hepsini seç checkbox true ya false hangisi ise onu diğer checkboxların içerisine atadık.
				checkBox.checked = selectProducts.checked;
			}
		});

	}

		//#endregion
	
	//#region Yüklenmek istenen son gün sayısı. Mesela: Son 14 gün getir gibi.

	onSelectedNumberOfDays(numberOfDay) {

		//Bu data burak biye gönderielcek ve subscribe ile yakalanan data tekrar behaviour subject ile yakalanacak.
		//ve producrt tekrar balışmış olacak
		console.log(numberOfDay);

		this.productLoadList(numberOfDay);

	}

		//#endregion
	
	//#region ÜrünKaydetme işlemleri

	btnRejectForAProject(operationType, product, pendingPRow) {


		//ngModel ile datalarımızı yakalıyoruz.
		let productList = this.selectedOneProductHolder(pendingPRow);

		const modalRef = this.modalService.open(ProductApprovalOrRejectModalComponent, { windowClass: 'dark-modal' });
		modalRef.componentInstance.operationType = operationType;
	
		modalRef.componentInstance.approvalConfirmSelected.subscribe(result => {

			if (result) {

				this._orderService.removeOrder(productList).subscribe(x => {

					this.uiMessage.modal.success("", this.customLocalization.l("FE.ALERTMESSAGES.COMMON.SUCCESSPROCESS"), () => {

						this.productLoadList(this.selectedLastNumberDayObj.value);

					});

					//this.getRemoveIsCanceledStatus(productList);

				});
			}
		})
	}

	//Onayla butonuna tıklandığında elementlerin içerisinde gezerek gerekli dataları yakalıyoruz.
	//Şuan ngModel ile datalarımızı yakalıyoruz üstteki yapı da bir alternatif sadece.
	btnSelectedRejected() {
		
		//ngModel ile datalarımızı yakalıyoruz.
		let productList = this.selectedProduct();
		if (productList.length < 1) {
			return;
		}

		const modalRef = this.modalService.open(ProductApprovalOrRejectModalComponent, { windowClass: 'dark-modal' });

		//İşlem tipinin reddetme olduğunu söyeldik sıfır ile bunu daha sonra enum yapısına bağlayacağız.
		modalRef.componentInstance.operationType = 2;

		modalRef.componentInstance.approvalConfirmSelected.subscribe(result => {

			if (result) {

				this._orderService.removeOrder(productList).subscribe(x => {

					this.uiMessage.modal.success("", this.customLocalization.l("FE.ALERTMESSAGES.COMMON.SUCCESSPROCESS"), () => {

						//Onaylama işlemi başarılı bir şekilde tamamlandıktan sonra listeyi tekrar yüklüyoruz.
						this.productLoadList(this.selectedLastNumberDayObj.value);
					});

					//this.getRemoveIsCanceledStatus(productList);
					
				});
			}
		})
	
	}

	//#endregion


	//Kullanıcı bir değeri silerse ilgili satırı kırmızıya alıp oraya tekrar talep girmesini engellilyoruz.
	getRemoveIsCanceledStatus(productList) {

		//İşlemler bittikten sonra herşey yolundaysa ürünler stok yetersiz ya da
		// onaylandığını belirten şeyler yapıyoruz.
		document.querySelectorAll(".myPenReqPlist").forEach((el) => {
			let orderDetailsId = (el.querySelector('.myPenReqOrderDetailsId') as HTMLElement).innerText;

			if (!!productList.find((x) => x.id == (+orderDetailsId))) {

				el.querySelector('.removeSuccess').setAttribute('style','display: block;');
				//(el.querySelector('.orderAmount') as HTMLButtonElement).disabled = true;
				(el.querySelector('.myPenReqPRowEdit-col input') as HTMLInputElement).checked = false;
				//(el.querySelector('.edit-col input') as HTMLInputElement).disabled = false;
				(el.querySelector('.pChckbx') as HTMLInputElement).parentNode.removeChild(el.querySelector('.pChckbx'));
				(el.querySelector('.btnMyPendingReqRejectAndStatus') as HTMLInputElement).parentNode.removeChild(el.querySelector('.btnMyPendingReqRejectAndStatus'));
				el.querySelector('.myPenReqPRow').setAttribute('style', 'border:  pointer-events: none;');

			}

		});

	}
		// #endregion


	//Product listesinin üzerinde ki resimlere tıklayınca buradan code göre url oluşturup modal açıp içine basıyoruz.
	openImage(productCode, pName) {

		let imgActualSize = ( AppConsts.productImage.url + '/' + productCode + '.jpg');

		const modalRef = this.modalService.open(ImageModalComponent, {
			size: 'md'
		});

		modalRef.componentInstance.imgActualSize = imgActualSize;
		modalRef.componentInstance.productCode = productCode;
		modalRef.componentInstance.productName = pName;
	}

	//#region ürünlerin onay durumu yani onaycılarından kimler onayladı kimler beklemede dedi.


	btnApprovalStatus(approvalUsers: OrderApprovalUserDto[], approvalUsersHasPersonInCharge: boolean) {

		const approveModalRef = this.modalService.open(ApproveStatusModalComponent, { windowClass: 'dark-modal' });

		approveModalRef.componentInstance.approvalUsers = approvalUsers;
		approveModalRef.componentInstance.approvalUsersHasPersonInCharge = approvalUsersHasPersonInCharge;

	}

		//#endregion

	//#region seçili olan ürünlerimi yakaladığım method

	//seçilen ürünleri bir tane listede tutmak için kullanıyoruz.
	//bu method sadece ikinci bir alternatif elementi yakalıyorak checkbox da checked olan dataları yakalıyoruz.
	selectedProduct() {

		this.selectedProductList = [];

		//pRow selectorunun içerisinde bulunduğu tüm yerleri alır. yani row ların hepsini buradan alırız.
		document.querySelectorAll('.myPenReqPRow').forEach((el) => {

			//Checkbox elementine eriştik.
			let checkbox = el.querySelector('.myPenReqPRowEdit-col input') as HTMLInputElement;

			//Eğer tıklanılan hepsini seç checkbox true ya false hangisi ise onu diğer checkboxların içerisine atadık.
			if (!!checkbox && checkbox.checked) {

				let orderDetailsId = (el.querySelector('.myPenReqOrderDetailsId') as HTMLElement).innerText;
				//let twinOrderDetailsId = (el.querySelector('.myPenReqTwinOrderDetailsId') as HTMLElement).innerText;

				this.selectedProductList.push(+orderDetailsId);

			}


		});

		return this.selectedProductList;

	}

		//#endregion



	//#region seçilmiş olan bir ürünü yakaldığım method

	//seçilen olan bir ürünü yakalarız. Yani tıklanılan ürünü yakalarız
	selectedOneProductHolder(pendingPRow) {

		this.selectedProductList = [];
		
		let orderDetailsId = (pendingPRow.querySelector('.myPenReqOrderDetailsId') as HTMLElement).innerText;
		//let twinOrderDetailsId = (pendingPRow.querySelector('.myPenReqTwinOrderDetailsId') as HTMLElement).innerText;

		this.selectedProductList.push(+orderDetailsId);

		

		return this.selectedProductList;

	}

	//#endregion

	

	//Fotoğrafların url döndermek için kullanıyoruz.
	getPhotoUrl(kod: string): string {
		return  AppConsts.productImage.url + '/' + kod + '.jpg'
	}
	
}


